import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "detail-root" }
const _hoisted_2 = { class: "top-bar" }
const _hoisted_3 = { class: "account-badge" }
const _hoisted_4 = { class: "avatar" }
const _hoisted_5 = { class: "name-line" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = {
  key: 0,
  class: "nick"
}
const _hoisted_8 = ["title"]
const _hoisted_9 = { class: "top-actions" }
const _hoisted_10 = { class: "status-strip" }
const _hoisted_11 = { class: "ss-item ss-switch" }
const _hoisted_12 = {
  key: 0,
  class: "ss-err"
}
const _hoisted_13 = { class: "ss-item" }
const _hoisted_14 = { class: "ss-item ss-room" }
const _hoisted_15 = { class: "ss-val" }
const _hoisted_16 = { class: "ss-item" }
const _hoisted_17 = { class: "ss-label" }
const _hoisted_18 = { class: "ss-val" }
const _hoisted_19 = {
  key: 0,
  class: "stats-bar"
}
const _hoisted_20 = { class: "stat-card" }
const _hoisted_21 = { class: "sc-val" }
const _hoisted_22 = {
  key: 0,
  class: "stat-card stat-dealer"
}
const _hoisted_23 = ["disabled", "title"]
const _hoisted_24 = {
  key: 1,
  class: "stat-card stat-cd",
  title: "当前房间 CD（锚点冷却剩余秒数）"
}
const _hoisted_25 = { class: "sc-val cd-val" }
const _hoisted_26 = { class: "content-wrap" }
const _hoisted_27 = { class: "scroll-area" }
const _hoisted_28 = {
  key: 0,
  class: "loading"
}
const _hoisted_29 = {
  key: 1,
  class: "empty"
}
const _hoisted_30 = { class: "record-grid" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = { class: "rec-top" }
const _hoisted_33 = { class: "rec-top-row1" }
const _hoisted_34 = {
  key: 0,
  class: "live-dot"
}
const _hoisted_35 = { class: "rec-desk" }
const _hoisted_36 = {
  key: 0,
  class: "rec-room-no"
}
const _hoisted_37 = {
  key: 1,
  class: "rec-status done"
}
const _hoisted_38 = ["title", "onClick"]
const _hoisted_39 = ["title", "onClick"]
const _hoisted_40 = ["title", "onClick"]
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 0,
  class: "rec-kill-desc"
}
const _hoisted_43 = {
  key: 0,
  class: "pk-real-showdown"
}
const _hoisted_44 = { class: "showdown-info" }
const _hoisted_45 = { class: "rec-time" }
const _hoisted_46 = { class: "rec-round" }
const _hoisted_47 = {
  key: 0,
  class: "rec-settle-time"
}
const _hoisted_48 = { class: "showdown-row" }
const _hoisted_49 = { class: "pc-rank" }
const _hoisted_50 = { class: "pc-suit" }
const _hoisted_51 = {
  key: 0,
  class: "playing-card empty"
}
const _hoisted_52 = { class: "showdown-vs" }
const _hoisted_53 = {
  key: 0,
  class: "vs-score-xian"
}
const _hoisted_54 = {
  key: 1,
  class: "vs-score-zhuang"
}
const _hoisted_55 = { class: "pc-rank" }
const _hoisted_56 = { class: "pc-suit" }
const _hoisted_57 = {
  key: 1,
  class: "playing-card empty"
}
const _hoisted_58 = {
  key: 1,
  class: "pk-zone"
}
const _hoisted_59 = { class: "pk-row" }
const _hoisted_60 = { class: "pk-cards" }
const _hoisted_61 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_62 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_63 = { class: "pk-row" }
const _hoisted_64 = { class: "pk-cards" }
const _hoisted_65 = {
  key: 0,
  class: "chip empty"
}
const _hoisted_66 = {
  key: 0,
  class: "pk-pts"
}
const _hoisted_67 = {
  key: 2,
  class: "pk-live"
}
const _hoisted_68 = { class: "showdown-info" }
const _hoisted_69 = { class: "rec-time" }
const _hoisted_70 = { class: "rec-round" }
const _hoisted_71 = {
  key: 0,
  class: "rec-settle-time"
}
const _hoisted_72 = { class: "live-wait" }
const _hoisted_73 = { class: "live-wait-txt" }
const _hoisted_74 = { class: "rec-amounts" }
const _hoisted_75 = { class: "am" }
const _hoisted_76 = { class: "am-val gold" }
const _hoisted_77 = { class: "am am-pc-only" }
const _hoisted_78 = { class: "am-val dim" }
const _hoisted_79 = { class: "am" }
const _hoisted_80 = { class: "am" }
const _hoisted_81 = { class: "am-val dim" }
const _hoisted_82 = {
  key: 0,
  class: "device-strip"
}
const _hoisted_83 = ["title"]
const _hoisted_84 = { class: "ds-item" }
const _hoisted_85 = { class: "ds-val ds-code" }
const _hoisted_86 = ["title"]
const _hoisted_87 = { class: "ds-val" }
const _hoisted_88 = { class: "ds-val" }
const _hoisted_89 = {
  key: 1,
  class: "ip-card"
}
const _hoisted_90 = { class: "ip-row" }
const _hoisted_91 = { class: "ip-v ip-addr" }
const _hoisted_92 = { class: "ip-row" }
const _hoisted_93 = { class: "ip-v" }
const _hoisted_94 = { class: "ip-row" }
const _hoisted_95 = { class: "ip-v ip-ver" }
const _hoisted_96 = { class: "pager-bar" }
const _hoisted_97 = {
  key: 0,
  class: "pg-num"
}
const _hoisted_98 = {
  key: 1,
  class: "pg-num"
}
const _hoisted_99 = { class: "shot-panel" }
const _hoisted_100 = { class: "shot-head" }
const _hoisted_101 = { class: "shot-meta" }
const _hoisted_102 = ["href"]
const _hoisted_103 = { class: "shot-body" }
const _hoisted_104 = ["src"]
const _hoisted_105 = ["title"]

import { ref, computed, watch, onMounted, onUnmounted, inject, type Ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { NSwitch } from 'naive-ui';
import Tools from '@/ts/Tools';
import { GAME_TYPE_MAP } from '@/ts/roomName';
import { resolveRoomName, setRoomNameMap } from '@/ts/roomNameStore';
import RoomVO from '@/ts/VO/RoomVO';
import RoomStateInfo from '@/ts/VO/RoomStateInfo';
import SignalRClient from '@/ts/SignalRClient';
import Config from '@/ts/Config';
import QuickKillPanel from '@/components/QuickKillPanel.vue';
import { useQuickKill } from '@/ts/useQuickKill';

type AuthDeviceBrief = {
  device_id?: string;
  auth_code?: string;
  status?: number;
  ip?: string;
  region?: string;
  online?: boolean | number;
  /** 插件版本号（扩展 WebSocket 的 ver= 参数上报；旧版扩展为空） */
  version?: string;
  /** 是否还有浏览器窗口（false = 插件后台常驻但窗口已全部关闭） */
  browser_open?: boolean;
  window_count?: number;
  latency?: number;
  latency_line?: number;
  last_seen_time?: number;
  last_login_time?: number;
};

const pageSize = 20;

// 推送已处理过的订单号 / 该订单已计入的收入金额（用于去重，重新拉页时清空）

export default /*@__PURE__*/_defineComponent({
  __name: 'AccountDetail',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));
const userName = ref(route.params.userName as string || '');
const nickName = ref('');

// ===== 全局控制面板（托管开关 + 参与门槛）=====
// 详情页是独立路由，不经过 HomeView，面板的数据需自行从服务端拉取
const {
  enabled: qkEnabled,
  partial: qkPartial,
  enabledCount: qkEnabledCount,
  amount: qkAmount,
  roomCount: qkRoomCount,
  noHostingOnDuplicate: qkNoHostingOnDuplicate,
  smartAnchorClean: qkSmartAnchorClean,
  load: qkLoad,
  save: qkSave,
  toggleNoHostingOnDuplicate,
} = useQuickKill();

// 重名策略就地切换（荷官角标按钮）：切换中防连点，失败短暂显示「切换失败」
const dupToggling = ref(false);
const dupFailed = ref(false);
let dupFailedTimer: number | null = null;

async function onToggleDupPolicy(): Promise<void> {
  if (dupToggling.value) return;
  dupToggling.value = true;
  try {
    const ok = await toggleNoHostingOnDuplicate();
    if (!ok) throw new Error('SetKillPigConfig 返回 false');
  } catch (e) {
    console.warn('[dup] 切换重名策略失败:', e);
    dupFailed.value = true;
    if (dupFailedTimer != null) clearTimeout(dupFailedTimer);
    dupFailedTimer = window.setTimeout(() => { dupFailed.value = false; }, 2500);
  } finally {
    dupToggling.value = false;
  }
}

// 返回时回到主播列表页（首页的“主播列表”标签）
function goBack() {
  router.push({ name: 'home', query: { tab: 'recharge' } });
}

// ===== 授权设备（授权码 / IP·地区）=====
// 数据与「授权管理-设备管理」同源：REST auth/list-devices 拉静态字段，
// SignalR onDeviceUpdate 推实时字段（在线、IP、延迟）。
// 展示为页面底部、分页之上的固定窄条（不随列表滚动）；延迟已移到顶栏名字下方，
// 不再占底部窄条的位置（字段太多、长文本会把它挤变形）。
const authDevice = ref<AuthDeviceBrief | null>(null);
/** IP 小卡片是否展开（设备条默认只显示中文归属地） */
const ipPop = ref(false);

/** 连接是否还在（扩展后台常驻也算在线） */
const deviceOnline = computed(() => {
  const d = authDevice.value;
  if (!d) return false;
  return d.online === true || Number(d.online) === 1;
});

/**
 * 设备展示态（与「授权管理-设备管理」同一口径）：
 * on=在线（有浏览器窗口） / closed=浏览器已关闭（扩展后台常驻，连接还在） / off=离线
 */
const deviceState = computed<'on' | 'closed' | 'off'>(() => {
  const d = authDevice.value;
  if (!d || !deviceOnline.value) return 'off';
  // 旧接口没有 browser_open 字段时按原来的在线处理
  return d.browser_open === false ? 'closed' : 'on';
});

/**
 * 条上只写最短的两个字：在线 / 离线。
 * 语境里就是设备状态（左边还有点色），不必再写「设备」二字。
 * 「浏览器已关闭」只体现在金点上（拍照仍禁用），不占文字宽度。
 */
const deviceStateText = computed(() => (deviceState.value === 'on' ? '在线' : '离线'));

/** 是否已授权：对应「授权管理」设备卡片上的启用开关（status 1=启用 / 0=禁用） */
const deviceAuthorized = computed(() => Number(authDevice.value?.status) === 1);

/** 设备条上默认展示的归属地（中文地区；IP 点开才看） */
const deviceRegionText = computed(() => authDevice.value?.region || '未知地区');

/** 插件版本：旧版插件不上报版本号，统一显示「老版本」而不是空/破折号 */
const deviceVersionText = computed(() => (authDevice.value?.version ? `v${authDevice.value.version}` : '老版本'));

/** 只有「在线且有窗口」才能拍照/遥控，与授权管理页的按钮禁用条件一致 */
const deviceCanShot = computed(() => deviceState.value === 'on');

const deviceShotHint = computed(() => {
  if (deviceState.value === 'on') return '让插件截一张当前页面';
  if (deviceState.value === 'closed') return '浏览器已关闭，无法拍照（需先打开浏览器窗口）';
  return '设备离线，无法拍照';
});

/** -1 = 未知（离线 / 旧版插件未上报 / 刚连上还没测到） */
function toLatencyMs(v: unknown): number {
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? Math.round(n) : -1;
}

/** 主地址延迟（WebSocket 往返） */
const deviceLatency = computed(() => toLatencyMs(authDevice.value?.latency));
/** 线路地址延迟（到线路域名的 HTTP 往返，与主地址相同时不上报） */
const deviceLatencyLine = computed(() => toLatencyMs(authDevice.value?.latency_line));

const deviceLatencyText = computed(() => {
  const parts: string[] = [];
  if (deviceLatency.value >= 0) parts.push(`${deviceLatency.value}ms`);
  if (deviceLatencyLine.value >= 0) parts.push(`线 ${deviceLatencyLine.value}ms`);
  return parts.length ? parts.join(' · ') : '-';
});

const deviceLatencyClass = computed(() => {
  const v = deviceLatency.value >= 0 ? deviceLatency.value : deviceLatencyLine.value;
  if (v < 0) return '';
  if (v <= 120) return 'lat-good';
  if (v <= 300) return 'lat-warn';
  return 'lat-bad';
});

const deviceLatencyTitle = computed(() => {
  const tips: string[] = [];
  if (deviceLatency.value >= 0) tips.push(`主 ${deviceLatency.value}ms（WebSocket 往返）`);
  if (deviceLatencyLine.value >= 0) tips.push(`线路 ${deviceLatencyLine.value}ms（到线路域名的 HTTP 首次响应）`);
  return tips.length ? tips.join('；') : '暂无延迟数据（设备离线或插件未上报）';
});

/** 多台设备时挑一台展示：有浏览器窗口优先 → 在线 → 已启用 → 最近心跳/最后登录 */
function pickAuthDevice(list: AuthDeviceBrief[]): AuthDeviceBrief | null {
  if (!list.length) return null;
  const score = (d: AuthDeviceBrief) => {
    const openFlag = d.browser_open === false ? 0 : 1;
    const onlineFlag = d.online === true || Number(d.online) === 1 ? 1 : 0;
    const enabledFlag = Number(d.status) === 1 ? 1 : 0;
    const seen = Number(d.last_seen_time) || Number(d.last_login_time) || 0;
    return openFlag * 1e20 + onlineFlag * 1e18 + enabledFlag * 1e16 + seen;
  };
  return [...list].sort((a, b) => score(b) - score(a))[0];
}

async function loadAuthDevice() {
  try {
    const resp = await Tools.FetchGetAsync<{ list: AuthDeviceBrief[] }>('auth/list-devices', {
      page: 1,
      limit: 50,
      status: -1,
      sort: 'last_login',
    });
    if (!resp.CheckIsOk()) return;
    authDevice.value = pickAuthDevice(resp.Data?.list ?? []);
  } catch {
    // 设备信息拿不到不影响详情页主功能，静默忽略
  }
}

// ---- 拍照：下发 CaptureScreenshot，插件截屏后由 onDeviceScreenshot 推回图片地址 ----
const shotSending = ref(false);
/** 当前预览的截图地址（空 = 不显示预览） */
const shotUrl = ref('');
const shotAt = ref(0);
let shotTimeoutTimer: ReturnType<typeof setTimeout> | null = null;

function clearShotTimeout() {
  if (shotTimeoutTimer) {
    window.clearTimeout(shotTimeoutTimer);
    shotTimeoutTimer = null;
  }
}

function armShotTimeout() {
  clearShotTimeout();
  shotTimeoutTimer = window.setTimeout(() => {
    shotTimeoutTimer = null;
    Tools.AlertError('拍照超时：20 秒内未收到截图，请确认浏览器窗口可见且未最小化');
  }, 20000);
}

async function handleCaptureDeviceShot() {
  const deviceId = authDevice.value?.device_id;
  if (!deviceId || !deviceCanShot.value || shotSending.value) return;
  shotSending.value = true;
  try {
    const resp = await SignalRClient.Instance.InvokeAsync<{ flag: boolean; errorMessage: string }>(
      'CaptureScreenshot',
      deviceId
    );
    if (resp?.flag) {
      armShotTimeout();
      Tools.AlertSuccess('拍照指令已发送，请稍候…');
    } else {
      Tools.AlertError(resp?.errorMessage || '拍照指令发送失败，设备可能不在线');
    }
  } catch (e: any) {
    Tools.AlertError(e?.message || '拍照指令发送失败');
  } finally {
    shotSending.value = false;
  }
}

/** 截图回推：先清超时，再弹预览 */
function onDeviceScreenshot(st: any) {
  if (!st?.url) return;
  clearShotTimeout();
  shotUrl.value = st.url.startsWith('http') ? st.url : `${Config.ORIGIN}${st.url}`;
  shotAt.value = st.ts || 0;
}

/** 截图失败（窗口最小化 / 无活动标签 / 上传失败等） */
function onDeviceScreenshotFailed(st: any) {
  clearShotTimeout();
  Tools.AlertError(`截图失败：${st?.error || '未知原因'}`);
}

/** 设备实时状态推送：只更新当前展示的那台 */
function onDeviceUpdate(st: any) {
  const cur = authDevice.value;
  if (!cur || !st?.deviceId || st.deviceId !== cur.device_id) return;
  if (st.online !== undefined) cur.online = st.online;
  if (st.windowCount !== undefined) cur.window_count = st.windowCount;
  if (st.browserOpen !== undefined) cur.browser_open = st.browserOpen;
  if (st.ip) cur.ip = st.ip;
  if (st.region) cur.region = st.region;
  if (st.version) cur.version = st.version;
  if (st.latency != null) cur.latency = st.latency;
  if (st.latencyLine != null) cur.latency_line = st.latencyLine;
  if (st.lastSeen != null) cur.last_seen_time = st.lastSeen;
}

// 实时状态（来自列表接口 / GetAccountBets / 服务端推送）
// 进入详情时先用列表已知的实时状态做种子，避免接口滞后导致误判“离线”
const online = ref(route.query.online === '1');
const onlineTime = ref((route.query.ot as string) || '');
const lastOfflineTime = ref((route.query.lo as string) || '');
const room = ref((route.query.room as string) || '');

// ===== 受控开关（账号当前所在房间的托管，口径与「受控房间状态」列表一致）=====
// 房间号来自服务端实时状态（GameType-GameCode，如 3001-120），开关状态从 GetRoomStates 里取，
// 切换直接调 SetRoomOpenKillPig，不做本页批量保存（避免和首页 selectRooms 全量覆盖打架）。
const roomState = ref<RoomStateInfo | null>(null);

/** 重名角标文案：智能清理（不做避让）优先，其次避让 / 照常 */
const dupLabel = computed(() => {
  if (qkSmartAnchorClean.value) return '重名·清理';
  return qkNoHostingOnDuplicate.value ? '重名·避让' : '重名·照常';
});

const dupTitle = computed(() => {
  if (qkSmartAnchorClean.value)
    return '智能清理：不做重名避让，换主播时清掉其他房间的同名残留锚点（点击切回重名避让）';
  return (qkNoHostingOnDuplicate.value
    ? '重名避让：同一系列内出现同名主播，该房间不参与托管'
    : '重名照常：同一系列内出现同名主播，仍允许该房间参与托管') + '（点击切换）';
});

/** 当前房间 CD 剩余秒数（来自 AnchorFloatPanel 的推送，0 = 无 CD） */
const roomCd = ref(0);
const roomKillPigLoading = ref(false);
const roomKillPigError = ref('');
let roomKillPigErrTimer: number | null = null;
/** 房间状态轮询（荷官名/重名/托管），页面停留期间保持最新 */
let roomStateTimer: number | null = null;
/** 设备信息补拉计数（授权状态没有实时推送，每 6 个周期=60s 重拉一次） */
let deviceTick = 0;

const canToggleRoomKillPig = computed(() =>
  !!roomState.value && !roomState.value.IsMaintaining && !!room.value && !roomKillPigLoading.value
);

const roomKillPigHint = computed(() => {
  if (!room.value) return '账号未在房间中，无法设置受控';
  if (!roomState.value) return `房间 ${room.value} 不在受控房间列表中`;
  if (roomState.value.IsMaintaining) return '房间维护中，不可操作托管';
  return `${room.value} 托管：${roomState.value.OpenKillPig ? '已开启' : '已关闭'}`;
});

function showRoomKillPigError(msg: string) {
  roomKillPigError.value = msg;
  if (roomKillPigErrTimer != null) window.clearTimeout(roomKillPigErrTimer);
  roomKillPigErrTimer = window.setTimeout(() => { roomKillPigError.value = ''; }, 4000);
}

/** 拉取当前房间的受控状态（房间不存在于受控列表时为 null → 开关禁用） */
async function syncRoomState() {
  const roomNumber = room.value;
  if (!roomNumber) {
    roomState.value = null;
    return;
  }
  try {
    const list = await SignalRClient.Instance.InvokeAsync<RoomStateInfo[]>('GetRoomStates');
    // 兼容 RoomNumber 字段缺失（前端类的 getter 在反序列化对象上不存在）
    roomState.value = (list ?? []).find(
      (r) => `${r.GameType}-${r.GameCode}` === roomNumber || r.RoomNumber === roomNumber
    ) ?? null;
  } catch {
    /* 静默：开关保持上一次状态，下次房间变化/列表更新时再同步 */
  }
}

async function onToggleRoomKillPig(open: boolean) {
  const st = roomState.value;
  if (!st || !canToggleRoomKillPig.value) return;
  roomKillPigLoading.value = true;
  try {
    const ok = await SignalRClient.Instance.InvokeAsync<boolean>(
      'SetRoomOpenKillPig', st.GameType, st.GameCode, open
    );
    if (ok !== true) {
      // 服务端没落地（房间已不存在/异常）：不做乐观更新，回读真实状态
      showRoomKillPigError('切换失败：房间不存在或服务端异常');
      await syncRoomState();
      return;
    }
    st.OpenKillPig = open; // 乐观更新，下次同步以服务端为准
    // 联动「总控」：房间开关变了，全开/部分/全关三态要立刻跟着变
    qkLoad().catch(() => {});
  } catch {
    showRoomKillPigError('切换失败：连接异常');
    await syncRoomState();
  } finally {
    roomKillPigLoading.value = false;
  }
}

/**
 * 总控保存：保存成功后立即回读当前房间的受控状态，
 * 让状态条上的「受控」开关跟上总控（原来要刷新页面才变）。
 */
async function handleQkSave(payload: { enabled: boolean; amount: number }) {
  const ok = await qkSave(payload);
  if (ok) {
    await syncRoomState();
  }
  return ok;
}

// 账号换房（含离线清空）时重新取受控状态；同时把 CD 清零，
// 否则会一直显示上一房间的倒计时（新房间无 CD 时更明显）
watch(room, () => {
  roomCd.value = 0;
  syncRoomState();
});

// 房间列表被清空（关闭拉取数据）时锚点面板会卸载，不会再推 CD，这里兜底清零
watch(qkRoomCount, (v) => {
  if (!v) roomCd.value = 0;
});

const range = ref('today');
const loading = ref(false);
const records = ref<any[]>([]);
const currentPage = ref(1);
const totalPages = ref(0);
const totalCount = ref(0);
const totalNetWin = ref(0);
const pushedOrders = new Set<string>();
const pushedWin = new Map<string, number>();

// ===== 伪装/真实卡牌切换（由父组件统一 debugMode 控制） =====
const REAL_SUIT: Record<string, string> = { spade: '♠', heart: '♥', club: '♣', diamond: '♦' };
const REAL_RANK: Record<number, string> = { 1: 'A', 11: 'J', 12: 'Q', 13: 'K' };
function realSuitSymbol(suit: string) { return REAL_SUIT[suit] || ''; }
function realRankDisplay(n: number) { return REAL_RANK[n] || String(n); }

const totalNetWinStr = computed(() => {
  const v = totalNetWin.value;
  return Tools.formatMoney(v, { showSign: true });
});
const netWinClass = computed(() => totalNetWin.value > 0 ? 'positive' : totalNetWin.value < 0 ? 'negative' : '');
const netWinCardClass = computed(() => totalNetWin.value > 0 ? 'card-win' : totalNetWin.value < 0 ? 'card-lose' : '');
function setRange(r: string) {
  range.value = r;
  currentPage.value = 1;
  loadData();
}

function goPage(p: number) {
  if (p < 1 || p > totalPages.value) return;
  currentPage.value = p;
  loadData();
}

async function loadData() {
  loading.value = true;
  try {
    const now = new Date();
    let start: string, end: string = toDateStr(now);
    if (range.value === 'today') start = end;
    else if (range.value === 'yesterday') { start = end = toDateStr(new Date(now.getTime() - 86400000)); }
    else if (range.value === '2d') start = toDateStr(new Date(now.getTime() - 86400000));
    else if (range.value === '3d') start = toDateStr(new Date(now.getTime() - 2 * 86400000));
    else if (range.value === '7d') start = toDateStr(new Date(now.getTime() - 6 * 86400000));
    else start = toDateStr(new Date(now.getTime() - 29 * 86400000));

    const resp = await Tools.FetchGetAsync<any>('game/account-bets', {
      userName: userName.value,
      startDate: start,
      endDate: end,
      page: currentPage.value,
      pageSize: pageSize
    });
    if (resp.CheckIsOk() && resp.Data) {
      records.value = resp.Data.data || [];
      // 整页重拉：服务端数据才是准的，清空推送去重账本
      pushedOrders.clear();
      pushedWin.clear();
      totalPages.value = resp.Data.pagecount || 0;
      totalCount.value = resp.Data.allcount || 0;
      // 后端聚合的统计，不再前端拉全量数据计算
      if (resp.Data.stats) {
        totalNetWin.value = resp.Data.stats.total_win || 0;
      }
      if (records.value.length > 0 && records.value[0].nickName) {
        nickName.value = records.value[0].nickName;
      }
      // 实时状态字段（服务端实时计算）
      // online 以“已确认为在线”为准：列表种子或服务端推送若已判在线，接口的滞后 false 不将其降级
      online.value = online.value || !!resp.Data.online;
      onlineTime.value = resp.Data.onlineTime || onlineTime.value;
      lastOfflineTime.value = resp.Data.lastOfflineTime || lastOfflineTime.value;
      room.value = resp.Data.room || room.value;
    }
  } finally {
    loading.value = false;
  }
}

function toDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

// ===== 直播间互动玩法映射（见 @/ts/roomName）=====
// 头部只显示房间号（EU1/EU5…）：游戏名（人气对决等）由页面级信息表达，记录头部不再重复占地方
function roomDisplayName(r: any): string {
  return r.game_zhuo_name || r.game_code || '';
}

// 房间编号（如 3001-57）：game_type-game_code，跟在房间号后面用弱化小字展示
function roomNo(r: any): string {
  if (r.game_type && r.game_code) return `${r.game_type}-${r.game_code}`;
  return '';
}

// ===== 直播互动结果判断（仅 debug/真实模式显示） =====

// 托管结论小行展开状态（按记录 key 记忆；手机端没悬停，点卡片展开看完整原因）。
// 必须用 ref：普通 Set 的改动不触发响应式更新，点了卡片界面不会变。
const killOpenMap = ref<Record<string, boolean>>({});
function recKey(r: any): string { return String(r.order_number || r.id || ''); }
function killOpen(r: any): boolean { return !!killOpenMap.value[recKey(r)]; }
function toggleKill(r: any): void {
  const k = recKey(r);
  const isOpen = !!killOpenMap.value[k];
  // 手风琴：同时只展开一个 —— 点开新卡，上一个自动收起；再点已展开的则收起
  killOpenMap.value = isOpen ? {} : { [k]: true };
}
// 模式B：点整条卡片展开/收起托管原因（手机上点击区域最大，不用精准点小标签）。
// 没有托管结论的卡片点了不反应；标签自身点击带 .stop，不会和卡片点击打架。
function onRecordClick(r: any): void {
  if (!(Number(r.kill_flag) > 0)) return;
  toggleKill(r);
}
function killFullText(r: any): string {
  if (r.kill_flag === 2) return `托管跳转：落在「${r.kill_desc || ''}」的锚点局`;
  return r.kill_desc || '';
}

function betLabel(r: any): string {
  // 下注那一刻就知道下的是什么（onBet 推送即带 bet_direction），不必等结算
  return r.bet_direction || '';
}

function betColorClass(r: any): string {
  // 未结算：蓝色「已下注·待开奖」态；结算后按盈亏上色
  if (!r.is_finish) return 'result-betting';
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'result-win';
  if (win < 0) return 'result-lose';
  return 'result-tie';
}

function formatTime(ts: number): string {
  const d = new Date(ts);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function winColor(val: number): string {
  if (val > 0) return 'positive';
  if (val < 0) return 'negative';
  return 'zero';
}

// 卡片底色按「玩家输赢」上色：正在下注=琥珀金 / 赢=绿 / 输=红 / 和(退本金)=中性金
function recordBoxClass(r: any): string {
  if (!r.is_finish) return 'res-betting';
  const win = Number(r.real_win_total_amount) || 0;
  if (win > 0) return 'res-win';
  if (win < 0) return 'res-lose';
  return 'res-tie';
}

// ===== 卡牌解析 =====
const SUIT_MAP: Record<string, { symbol: string; cls: string }> = {
  S: { symbol: '🖤', cls: 'spade' },    // 黑桃 — 黑色心/桃
  H: { symbol: '❤️', cls: 'heart' },    // 红桃 — 红色心
  C: { symbol: '🌸', cls: 'club' },     // 梅花 — 花
  D: { symbol: '🟦', cls: 'diamond' },  // 方片 — 方块
};
const RANK_VALUE: Record<string, number> = { '1': 1, '2': 2, '3': 3, '4': 4, '5': 5, '6': 6, '7': 7, '8': 8, '9': 9, '10': 10, '11': 11, '12': 12, '13': 13 };

function parseCards(raw: string | null): { count: number; symbol: string; suit: string }[] {
  if (!raw || raw === '-' || raw === '[]') return [];
  try {
    const arr: string[] = JSON.parse(raw);
    if (!Array.isArray(arr)) return [];
    return arr
      .filter((c: string) => typeof c === 'string' && c.includes('.'))
      .map((c: string) => {
        const [suit, rank] = c.split('.');
        const info = SUIT_MAP[suit] || { symbol: suit, cls: '' };
        return { count: RANK_VALUE[rank] || 0, symbol: info.symbol, suit: info.cls };
      });
  } catch {
    return [];
  }
}

// 下注/结算推送：服务端已带完整记录，前端直接插入/更新列表，不重新拉取整页
function applyPushedRecord(rec: any) {
  // 只处理当前查看的账号；列表按 bet_time 倒序，新记录只可能落在第 1 页
  if (!rec || !rec.order_number) return;
  if (rec.userName !== userName.value) return;
  if (currentPage.value !== 1) return;
  // “昨天”区间不含今天，推送的新记录不属于该区间，直接丢弃
  if (range.value === 'yesterday') return;

  const no = rec.order_number;
  const idx = records.value.findIndex((r: any) => r && r.order_number === no);
  if (idx >= 0) {
    // 已存在（例如刚打开页面已经刷到这条）→ 原地更新，不新增条目，避免重复
    records.value[idx] = rec;
  } else if (!pushedOrders.has(no)) {
    // 新记录插到最前；超过每页固定条数则移除末尾多余的（推送 100 条也只显示一页）
    records.value = [rec, ...records.value].slice(0, pageSize);
    totalCount.value += 1;                                   // 直播场次
    totalPages.value = Math.max(totalPages.value, Math.ceil(totalCount.value / pageSize));
  }
  pushedOrders.add(no);

  // 结算推送到达：自动展开这条的托管原因（手风琴，只展开这一个；下注推送不展开）
  if (rec.is_finish === 1 && Number(rec.kill_flag) > 0) {
    killOpenMap.value = { [recKey(rec)]: true };
  }

  // 直播收入：仅已结算才计入；同一单只累加差额，避免下注→结算两次推送重复计
  if (rec.is_finish === 1) {
    const win = Number(rec.real_win_total_amount) || 0;
    totalNetWin.value += win - (pushedWin.get(no) || 0);
    pushedWin.set(no, win);
  }
  if (rec.nickName) nickName.value = rec.nickName;
}
const onAccountDataPush = (data: any) => applyPushedRecord(data?.record);

// 房间列表变化 → 重新同步面板（房间数决定托管开关是否可点），并刷新当前房间的受控状态
const onRoomListUpdate = () => {
  qkLoad().catch(() => {});
  syncRoomState();
};

onMounted(() => {
  loadData();

  // 全局控制面板：拉取托管开关/门槛/房间数（深链进入也能正确显示）
  qkLoad().catch(() => {});
  // 受控开关：拉取账号当前房间的托管状态（深链进入时 room 来自 query）
  syncRoomState();
  // 授权设备（授权码 / IP·地区 / 延迟）
  loadAuthDevice();

  // 荷官名 / 重名 / 托管会随直播进程变化，停留期间每 10s 轻量同步一次（后台标签页不拉）
  roomStateTimer = window.setInterval(() => {
    if (document.visibilityState !== 'visible') return;
    // 设备未完全就绪（离线 / 浏览器已关闭）时顺手重拉设备列表；
    // 在线且有窗口后在线/延迟靠 onDeviceUpdate 实时更新，但「授权状态」没有推送，每 60s 补拉一次
    deviceTick += 1;
    if (deviceState.value !== 'on' || deviceTick % 6 === 0) loadAuthDevice();
    if (online.value && room.value) syncRoomState();
  }, 10000);
  // 房间列表变化（服务端拉取数据开关切换）时同步面板的房间数
  SignalRClient.Instance.AddEventListener('onRoomListUpdate', onRoomListUpdate);
  // 授权设备实时状态（在线/IP/延迟）
  SignalRClient.Instance.AddEventListener('onDeviceUpdate', onDeviceUpdate);
  // 设备拍照：成功推图 / 失败推错误原因
  SignalRClient.Instance.AddEventListener('onDeviceScreenshot', onDeviceScreenshot);
  SignalRClient.Instance.AddEventListener('onDeviceScreenshotFailed', onDeviceScreenshotFailed);

  // 兜底：深链/刷新进入时首页未加载房间列表，主动拉一次填充 RoomNumber->RoomName 映射
  SignalRClient.Instance.InvokeAsync<{ [key: string]: RoomVO }>("GetRoomList")
    .then((resp) => {
      const list: RoomVO[] = [];
      for (const key in resp) {
        const room = resp[key];
        Object.setPrototypeOf(room, RoomVO.prototype);
        list.push(room);
      }
      setRoomNameMap(list);
    })
    .catch(() => {});
  // 服务端推送的账号状态实时更新（在线/房间/时间）
  SignalRClient.Instance.AddEventListener("onUserStatusUpdate", (data: any) => {
    if (data?.userName !== userName.value) return;
    online.value = !!data.online;
    onlineTime.value = data.onlineTime || '';
    lastOfflineTime.value = data.lastOfflineTime || '';
    room.value = data.room || '';
  });
  // 下注/结算推送：服务端带完整记录，前端直接插入/更新（去重 + 限制每页条数）
  SignalRClient.Instance.AddEventListener("onBet", onAccountDataPush);
  SignalRClient.Instance.AddEventListener("onSettle", onAccountDataPush);
});

onUnmounted(() => {
  SignalRClient.Instance.RemoveEventListener("onUserStatusUpdate");
  SignalRClient.Instance.RemoveEventListener("onBet");
  SignalRClient.Instance.RemoveEventListener("onSettle");
  SignalRClient.Instance.RemoveEventListener("onRoomListUpdate");
  SignalRClient.Instance.RemoveEventListener("onDeviceUpdate");
  SignalRClient.Instance.RemoveEventListener("onDeviceScreenshot");
  SignalRClient.Instance.RemoveEventListener("onDeviceScreenshotFailed");
  clearShotTimeout();
  if (roomKillPigErrTimer != null) {
    window.clearTimeout(roomKillPigErrTimer);
    roomKillPigErrTimer = null;
  }
  if (roomStateTimer != null) {
    window.clearInterval(roomStateTimer);
    roomStateTimer = null;
  }
  if (dupFailedTimer != null) {
    window.clearTimeout(dupFailedTimer);
    dupFailedTimer = null;
  }
});

function fmtTime(v: any): string {
  if (!v) return '';
  const d = new Date(v);
  if (isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "back",
        onClick: goBack
      }, "↩"),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(userName.value.charAt(0)), 1),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(userName.value), 1),
          (nickName.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(nickName.value), 1))
            : _createCommentVNode("", true),
          _createElementVNode("span", {
            class: _normalizeClass(["name-lat", deviceLatencyClass.value]),
            title: deviceLatencyTitle.value
          }, [
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "nl-label" }, "延迟", -1)),
            _createTextVNode(_toDisplayString(deviceLatencyText.value), 1)
          ], 10, _hoisted_8)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'today' }]),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (setRange('today')))
        }, "今", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === 'yesterday' }]),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (setRange('yesterday')))
        }, "昨", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '2d' }]),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (setRange('2d')))
        }, "2d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '3d' }]),
          onClick: _cache[3] || (_cache[3] = ($event: any) => (setRange('3d')))
        }, "3d", 2),
        _createElementVNode("span", {
          class: _normalizeClass(["range-btn", { on: range.value === '7d' }]),
          onClick: _cache[4] || (_cache[4] = ($event: any) => (setRange('7d')))
        }, "7d", 2)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "ss-label" }, "单控", -1)),
        _createVNode(_unref(NSwitch), {
          size: "small",
          value: !!roomState.value?.OpenKillPig,
          loading: roomKillPigLoading.value,
          disabled: !canToggleRoomKillPig.value,
          title: roomKillPigHint.value,
          "onUpdate:value": onToggleRoomKillPig
        }, null, 8, ["value", "loading", "disabled", "title"])
      ]),
      (roomKillPigError.value)
        ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(roomKillPigError.value), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_13, [
        _cache[15] || (_cache[15] = _createElementVNode("span", { class: "ss-label" }, "状态", -1)),
        _createElementVNode("span", {
          class: _normalizeClass(["ss-val", online.value ? 'on' : 'off'])
        }, _toDisplayString(online.value ? '直播中' : '离线'), 3)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "ss-label" }, "房间", -1)),
        _createElementVNode("span", _hoisted_15, _toDisplayString(_unref(resolveRoomName)(room.value) || '未进房'), 1)
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("span", _hoisted_17, _toDisplayString(online.value ? '上线' : '离线'), 1),
        _createElementVNode("span", _hoisted_18, _toDisplayString(online.value
            ? (onlineTime.value ? fmtTime(onlineTime.value) : '—')
            : (lastOfflineTime.value ? fmtTime(lastOfflineTime.value) : '—')), 1)
      ])
    ]),
    (_unref(debugMode))
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("div", _hoisted_20, [
            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "sc-label" }, "直播场次", -1)),
            _createElementVNode("span", _hoisted_21, _toDisplayString(totalCount.value), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["stat-card", netWinCardClass.value])
          }, [
            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "sc-label" }, "直播收入", -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["sc-val", netWinClass.value])
            }, _toDisplayString(totalNetWinStr.value), 3)
          ], 2),
          (roomState.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _cache[19] || (_cache[19] = _createElementVNode("span", { class: "sc-label" }, "荷官", -1)),
                _createElementVNode("span", {
                  class: _normalizeClass(["sc-val dealer-name", { dup: roomState.value.IsDuplicateDealer }])
                }, _toDisplayString(roomState.value.DealerName || '未到齐'), 3),
                (roomState.value.IsDuplicateDealer)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      type: "button",
                      class: _normalizeClass(["dup-tag", {
            'is-avoid': _unref(qkNoHostingOnDuplicate) && !_unref(qkSmartAnchorClean),
            'is-clean': _unref(qkSmartAnchorClean),
            busy: dupToggling.value,
            failed: dupFailed.value,
          }]),
                      disabled: dupToggling.value,
                      title: dupTitle.value,
                      onClick: _withModifiers(onToggleDupPolicy, ["stop"])
                    }, _toDisplayString(dupToggling.value ? '切换中…' : dupFailed.value ? '切换失败' : dupLabel.value), 11, _hoisted_23))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (roomCd.value > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                _cache[20] || (_cache[20] = _createElementVNode("span", { class: "sc-label" }, "CD", -1)),
                _createElementVNode("span", _hoisted_25, _toDisplayString(roomCd.value) + "s", 1)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_28, "正在拉取直播数据..."))
          : (records.value.length === 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_29, "暂无直播记录"))
            : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_30, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(records.value, (r) => {
            return (_openBlock(), _createElementBlock("div", {
              class: _normalizeClass(["record", [recordBoxClass(r), { unfinished: !r.is_finish, expanded: killOpen(r), clickable: r.kill_flag > 0 }]]),
              key: r.order_number || r.id,
              onClick: ($event: any) => (onRecordClick(r))
            }, [
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  (!r.is_finish)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34))
                    : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_35, [
                    _createTextVNode(_toDisplayString(roomDisplayName(r)), 1),
                    (roomNo(r))
                      ? (_openBlock(), _createElementBlock("i", _hoisted_36, _toDisplayString(roomNo(r)), 1))
                      : _createCommentVNode("", true)
                  ]),
                  (r.is_finish)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_37, "已结束"))
                    : _createCommentVNode("", true),
                  (r.kill_flag === 2)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 2,
                        class: _normalizeClass(["rec-kill-tag kill", { open: killOpen(r) }]),
                        title: `跳转：落在「${r.kill_desc}」的锚点局`,
                        onClick: _withModifiers(($event: any) => (toggleKill(r)), ["stop"])
                      }, _cache[21] || (_cache[21] = [
                        _createTextVNode("跳"),
                        _createElementVNode("i", { class: "k-arrow" }, "▾", -1)
                      ]), 10, _hoisted_38))
                    : (r.kill_flag === 1)
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 3,
                          class: _normalizeClass(["rec-kill-tag natural", { open: killOpen(r) }]),
                          title: r.kill_desc,
                          onClick: _withModifiers(($event: any) => (toggleKill(r)), ["stop"])
                        }, _cache[22] || (_cache[22] = [
                          _createTextVNode("然"),
                          _createElementVNode("i", { class: "k-arrow" }, "▾", -1)
                        ]), 10, _hoisted_39))
                      : (r.kill_flag === 3)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 4,
                            class: _normalizeClass(["rec-kill-tag noskill", { open: killOpen(r) }]),
                            title: r.kill_desc,
                            onClick: _withModifiers(($event: any) => (toggleKill(r)), ["stop"])
                          }, _cache[23] || (_cache[23] = [
                            _createTextVNode("略"),
                            _createElementVNode("i", { class: "k-arrow" }, "▾", -1)
                          ]), 10, _hoisted_40))
                        : _createCommentVNode("", true),
                  (_unref(debugMode) && betLabel(r))
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 5,
                        class: _normalizeClass(["rec-result-chip", betColorClass(r)])
                      }, [
                        _createTextVNode(_toDisplayString(betLabel(r)), 1),
                        (r.odds)
                          ? (_openBlock(), _createElementBlock("i", _hoisted_41, " · " + _toDisplayString(r.odds), 1))
                          : _createCommentVNode("", true)
                      ], 2))
                    : _createCommentVNode("", true)
                ]),
                (killOpen(r))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, _toDisplayString(killFullText(r)), 1))
                  : _createCommentVNode("", true)
              ]),
              (_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, [
                    _createElementVNode("div", _hoisted_44, [
                      _createElementVNode("span", _hoisted_45, _toDisplayString(formatTime(r.bet_time)), 1),
                      _createElementVNode("span", _hoisted_46, "第" + _toDisplayString(r.main_ju_number) + "回合", 1),
                      (r.settlement_time)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_47, "结束于 " + _toDisplayString(formatTime(r.settlement_time)), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_48, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["playing-card", c.suit]),
                          key: 'x'+ci
                        }, [
                          _createElementVNode("span", _hoisted_49, _toDisplayString(realRankDisplay(c.count)), 1),
                          _createElementVNode("span", _hoisted_50, _toDisplayString(realSuitSymbol(c.suit)), 1)
                        ], 2))
                      }), 128)),
                      (!parseCards(r.xian_cards).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[24] || (_cache[24] = [
                            _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                          ])))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_52, [
                        (r.xian_dian != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(r.xian_dian), 1))
                          : _createCommentVNode("", true),
                        _cache[25] || (_cache[25] = _createElementVNode("span", { class: "vs-word" }, "vs", -1)),
                        (r.zhuang_dian != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(r.zhuang_dian), 1))
                          : _createCommentVNode("", true)
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: _normalizeClass(["playing-card", c.suit]),
                          key: 'z'+ci
                        }, [
                          _createElementVNode("span", _hoisted_55, _toDisplayString(realRankDisplay(c.count)), 1),
                          _createElementVNode("span", _hoisted_56, _toDisplayString(realSuitSymbol(c.suit)), 1)
                        ], 2))
                      }), 128)),
                      (!parseCards(r.zhuang_cards).length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_57, _cache[26] || (_cache[26] = [
                            _createElementVNode("span", { class: "pc-rank" }, "-", -1)
                          ])))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : (!_unref(debugMode) && (r.xian_cards || r.zhuang_cards))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                      _createElementVNode("div", _hoisted_59, [
                        _cache[28] || (_cache[28] = _createElementVNode("span", { class: "pk-tag blue" }, "我方", -1)),
                        _createElementVNode("span", _hoisted_60, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.xian_cards), (c, ci) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: _normalizeClass(["chip", c.suit]),
                              key: 'x'+ci
                            }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                          }), 128)),
                          (!parseCards(r.xian_cards).length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_61, "-"))
                            : _createCommentVNode("", true)
                        ]),
                        (r.xian_dian != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_62, [
                              _createTextVNode(_toDisplayString(r.xian_dian), 1),
                              _cache[27] || (_cache[27] = _createElementVNode("i", null, "分", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "pk-divider" }, [
                        _createElementVNode("span", null, "VS")
                      ], -1)),
                      _createElementVNode("div", _hoisted_63, [
                        _cache[30] || (_cache[30] = _createElementVNode("span", { class: "pk-tag red" }, "对方", -1)),
                        _createElementVNode("span", _hoisted_64, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(parseCards(r.zhuang_cards), (c, ci) => {
                            return (_openBlock(), _createElementBlock("span", {
                              class: _normalizeClass(["chip", c.suit]),
                              key: 'z'+ci
                            }, _toDisplayString(c.symbol) + "×" + _toDisplayString(c.count), 3))
                          }), 128)),
                          (!parseCards(r.zhuang_cards).length)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_65, "-"))
                            : _createCommentVNode("", true)
                        ]),
                        (r.zhuang_dian != null)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_66, [
                              _createTextVNode(_toDisplayString(r.zhuang_dian), 1),
                              _cache[29] || (_cache[29] = _createElementVNode("i", null, "分", -1))
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("span", _hoisted_69, _toDisplayString(formatTime(r.bet_time)), 1),
                        _createElementVNode("span", _hoisted_70, "第" + _toDisplayString(r.main_ju_number) + "-" + _toDisplayString(r.sub_ju_number) + "回合", 1),
                        (r.settlement_time)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_71, "结束于 " + _toDisplayString(formatTime(r.settlement_time)), 1))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_72, [
                        _cache[32] || (_cache[32] = _createElementVNode("i", { class: "card-back" }, null, -1)),
                        _cache[33] || (_cache[33] = _createElementVNode("i", { class: "card-back" }, null, -1)),
                        _createElementVNode("span", _hoisted_73, _toDisplayString(r.is_finish ? '本局无牌面记录' : '等待开牌…'), 1),
                        _cache[34] || (_cache[34] = _createElementVNode("i", { class: "card-back" }, null, -1)),
                        _cache[35] || (_cache[35] = _createElementVNode("i", { class: "card-back" }, null, -1))
                      ])
                    ])),
              _createElementVNode("div", _hoisted_74, [
                _createElementVNode("div", _hoisted_75, [
                  _cache[36] || (_cache[36] = _createElementVNode("span", { class: "am-icon" }, "投", -1)),
                  _createElementVNode("span", _hoisted_76, _toDisplayString(_unref(Tools).formatMoney(r.total_betting_amount)), 1)
                ]),
                _createElementVNode("div", _hoisted_77, [
                  _cache[37] || (_cache[37] = _createElementVNode("span", { class: "am-icon" }, "效", -1)),
                  _createElementVNode("span", _hoisted_78, _toDisplayString(_unref(Tools).formatMoney(r.effective_betting_amount)), 1)
                ]),
                _createElementVNode("div", _hoisted_79, [
                  _cache[38] || (_cache[38] = _createElementVNode("span", { class: "am-icon" }, "赢", -1)),
                  _createElementVNode("span", {
                    class: _normalizeClass(["am-val", winColor(r.real_win_total_amount)])
                  }, _toDisplayString(_unref(Tools).formatMoney(r.real_win_total_amount)), 3)
                ]),
                _createElementVNode("div", _hoisted_80, [
                  _cache[39] || (_cache[39] = _createElementVNode("span", { class: "am-icon" }, "额", -1)),
                  _createElementVNode("span", _hoisted_81, _toDisplayString(_unref(Tools).formatMoney(r.front_balance)) + " → " + _toDisplayString(_unref(Tools).formatMoney(r.after_balance)), 1)
                ])
              ])
            ], 10, _hoisted_31))
          }), 128))
        ])
      ]),
      (authDevice.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
            _createElementVNode("span", {
              class: _normalizeClass(["ds-dot", deviceState.value]),
              title: deviceState.value === 'closed' ? '浏览器已关闭' : deviceStateText.value
            }, null, 10, _hoisted_83),
            _createElementVNode("span", {
              class: _normalizeClass(["ds-state", deviceState.value])
            }, _toDisplayString(deviceStateText.value), 3),
            _createElementVNode("span", {
              class: _normalizeClass(["ds-auth", { 'is-off': !deviceAuthorized.value }])
            }, _toDisplayString(deviceAuthorized.value ? '已授权' : '已禁用'), 3),
            _createElementVNode("span", _hoisted_84, [
              _cache[40] || (_cache[40] = _createElementVNode("span", { class: "ds-label" }, "授权码", -1)),
              _createElementVNode("span", _hoisted_85, _toDisplayString(authDevice.value.auth_code || '-'), 1)
            ]),
            _createElementVNode("span", {
              class: _normalizeClass(["ds-item ds-ver", { 'is-old': !authDevice.value.version }]),
              title: authDevice.value.version ? `插件版本 v${authDevice.value.version}` : '未上报版本号，可能是老版本插件'
            }, [
              _createElementVNode("span", _hoisted_87, _toDisplayString(deviceVersionText.value), 1)
            ], 10, _hoisted_86),
            _createElementVNode("span", {
              class: "ds-item ds-region",
              title: "点击查看 IP 地址",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (ipPop.value = !ipPop.value))
            }, [
              _createElementVNode("span", _hoisted_88, _toDisplayString(deviceRegionText.value), 1)
            ])
          ]))
        : _createCommentVNode("", true),
      (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
        (ipPop.value)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "ip-mask",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (ipPop.value = false))
            }))
          : _createCommentVNode("", true),
        (ipPop.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_89, [
              _createElementVNode("div", _hoisted_90, [
                _cache[41] || (_cache[41] = _createElementVNode("span", { class: "ip-k" }, "IP", -1)),
                _createElementVNode("span", _hoisted_91, _toDisplayString(authDevice.value?.ip || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_92, [
                _cache[42] || (_cache[42] = _createElementVNode("span", { class: "ip-k" }, "归属地", -1)),
                _createElementVNode("span", _hoisted_93, _toDisplayString(deviceRegionText.value), 1)
              ]),
              _createElementVNode("div", _hoisted_94, [
                _cache[43] || (_cache[43] = _createElementVNode("span", { class: "ip-k" }, "插件版本", -1)),
                _createElementVNode("span", _hoisted_95, _toDisplayString(deviceVersionText.value), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ])),
      _createElementVNode("div", _hoisted_96, [
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value <= 1 }]),
          onClick: _cache[7] || (_cache[7] = ($event: any) => (goPage(currentPage.value - 1)))
        }, "‹", 2),
        (totalPages.value > 0)
          ? (_openBlock(), _createElementBlock("span", _hoisted_97, _toDisplayString(currentPage.value) + " / " + _toDisplayString(totalPages.value) + " 页", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_98, "暂无数据")),
        _createElementVNode("span", {
          class: _normalizeClass(["pg-btn", { off: currentPage.value >= totalPages.value }]),
          onClick: _cache[8] || (_cache[8] = ($event: any) => (goPage(currentPage.value + 1)))
        }, "›", 2)
      ])
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (shotUrl.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "shot-mask",
            onClick: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (shotUrl.value = ''), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("div", _hoisted_100, [
                _cache[44] || (_cache[44] = _createElementVNode("span", { class: "shot-title" }, "设备截图", -1)),
                _createElementVNode("span", _hoisted_101, [
                  _createTextVNode(_toDisplayString(authDevice.value?.auth_code || ''), 1),
                  (shotAt.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" · " + _toDisplayString(fmtTime(shotAt.value)), 1)
                      ], 64))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("a", {
                  class: "shot-link",
                  href: shotUrl.value,
                  target: "_blank",
                  rel: "noreferrer"
                }, "新窗口打开", 8, _hoisted_102),
                _createElementVNode("span", {
                  class: "shot-close",
                  title: "关闭",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (shotUrl.value = ''))
                }, "✕")
              ]),
              _createElementVNode("div", _hoisted_103, [
                _createElementVNode("img", {
                  src: shotUrl.value,
                  class: "shot-img",
                  alt: "设备截图"
                }, null, 8, _hoisted_104)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    (authDevice.value)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          class: _normalizeClass(["float-shot", { off: !deviceCanShot.value, busy: shotSending.value }]),
          title: deviceShotHint.value,
          onClick: handleCaptureDeviceShot
        }, _toDisplayString(shotSending.value ? '···' : '拍照'), 11, _hoisted_105))
      : _createCommentVNode("", true),
    _createElementVNode("span", {
      class: "float-refresh",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (loadData()))
    }, "↻"),
    _createVNode(QuickKillPanel, {
      enabled: _unref(qkEnabled),
      partial: _unref(qkPartial),
      "enabled-count": _unref(qkEnabledCount),
      amount: _unref(qkAmount),
      "room-count": _unref(qkRoomCount),
      room: room.value,
      "room-name": _unref(resolveRoomName)(room.value),
      "on-save": handleQkSave,
      "on-refresh": _unref(qkLoad),
      onCdChange: _cache[12] || (_cache[12] = ($event: any) => (roomCd.value = $event))
    }, null, 8, ["enabled", "partial", "enabled-count", "amount", "room-count", "room", "room-name", "on-refresh"])
  ]))
}
}

})